import DateTimeUtil from './date-time-util';

const LocationUtil = {

  constants: {
    measureUnitMetersSymbol: 'm',
    measureUnitFeetSymbol: 'ft',
    metersToFtConversion: 3.28084,
  },

  getMeasuredAccuracy(accuracyValue) {
    if (DateTimeUtil.isUsLocaleUsed()) {
      return Math.round(accuracyValue * this.constants.metersToFtConversion)
        + this.constants.measureUnitFeetSymbol;
    }

    return accuracyValue + this.constants.measureUnitMetersSymbol;
  },

  retrievePosition(successCallback, errorCallback) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const accuracy = position.coords.accuracy;

        return successCallback({ latitude, longitude, accuracy });
      },
      (error) => errorCallback(error),
      {
        maximumAge: 60000,
        timeout: 5000,
        enableHighAccuracy: true,
      },
    );
  },
};

export default LocationUtil;
